// Typelizer digest 2cb9b2b6a92a706a7b9b3309890ed46c
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** PATCH /passkeys/reauthentication */
  update: (options?: RouteOptions): RouteDefinition<'patch'> => ({
    url: buildUrl('/passkeys/reauthentication', {}, options),
    method: 'patch',
  }),

  /** POST /passkeys/reauthentication */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/passkeys/reauthentication', {}, options),
    method: 'post',
  }),
}
